import React, { useState, Fragment } from 'react';
import UserTable from './UserTable';
import CheckAddDialog from './CheckAddDialog';
import CheckEditDialog from './CheckEditDialog';
import { Config } from '../config/config';
import InfoMsgBox from '../UIComponents/MessageBox/InfoMsgBox';
import { confirmAlert } from 'react-confirm-alert';
import Cookie from 'js-cookie';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import LZString from 'lz-string';
import 'react-confirm-alert/src/react-confirm-alert.css';

const CheckEdit = (props) => {
  const usersData = props.checkArray;

  const storeId = props.storeId;
  const usersData1 = props.category;
  const checkGroupId = props.checkGroupId;
  const config = JSON.parse(Config);
  const jsonData = Cookie.get('currentUser');
            let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
  const userInfo = JSON.parse(decompressedData)
  let userID = userInfo['userId'];

  const initialFormState = {
    id: null,
    name: '',
    category: '',
    subCategory: '',
    newCategory: '',
    newSubCategory: '',
    questionType: '',
  };

  // Setting state
  const [users] = useState(usersData);
  const [modalOpen] = useState(false);
  const [msg] = useState('');

  const [apiInterface, setApiInterface] = useState(config['api']);
  const [category, setCategory] = useState(usersData1);
  const [no, setNo] = useState(null);

  const [currentUser, setCurrentUser] = useState(initialFormState);
  const [editing, setEditing] = useState(false);

  // CRUD operations
  const addUser = (user) => {
    const addData = {
      checklistCategory: user.category,
      checklistCreatedBy: userID,
      checklistDescription: user.name,
      checklistGroupId: checkGroupId,
      checklistId: 0,
      checklistSubCategory: user.subCategory,
      questionType: user.questionType,
      storeId: storeId,
    };

    user.id = category.length + 1;

    category.map((index, i) => {
      let catVar = index.category === user.category;

      index.subCategory.map((index1, i1) => {
        let subCatVar = index1.subCategory === user.subCategory;
        if (subCatVar && catVar) {
          let temp = { id: 10, name: user.name };
          category[i].subCategory[i1].name.push(temp);
        }
      });
    });

    // setCategory(category);
    props.loadCat(category);

    ApiGateWay.Post(apiInterface + '/saveChecklistQuestion', addData)
      .then((response) => response.json())
      .then((response) => {
        //setNo(localStorage.getItem('expandedNo'));
        toast.success('Question is added!');

        setTimeout(() => {
          props.refreshData();
        }, 2000);
      })
      .catch((error) => {
        toast.error('Something is went wrong please try again later!');
      });
  };

  const deleteUser = (id) => {
    setEditing(false);

    confirmAlert({
      title: 'Confirm to delete',
      message: 'Are you sure to do this.',
      buttons: [
        {
          label: 'Yes',
          background: 'red',
          onClick: () => {
            ApiGateWay.Post(
              apiInterface +
                '/deleteChecklistQuestion?checklistId=' +
                id +
                '&storeId=' +
                storeId
            )
              .then((response) => response.json())
              .then((response) => {
                if (
                  response.errorMessage === 'Token Expired' ||
                  response.errorMessage === 'Invalid Token:::JWT expired' ||
                  response.errorMessage ===
                    'Your session has expired. Please login again.'
                ) {
                  Cookie.remove('currentUser');
                  Cookie.remove('stores');
                  Cookie.remove('storesAll');
                  Cookie.remove('warehouses');
                  localStorage.clear();
                  sessionStorage.clear();
                  this.setState({
                    loading: false,
                    modalOpen: true,
                    message:
                      'Your session has been expired and you will be redirected to the login page!!',
                  });
                  setTimeout(() => {
                    return (window.location = '/');
                  }, 4000);
                }
                toast.success('Question is Deleted!');
                setTimeout(() => {
                  props.refreshData();
                }, 2000);
              })
              .catch((error) => {
                toast.error('Something is went wrong please try again later!!');
              });
          },
        },
        {
          label: 'No',
          onClick: () => '',
        },
      ],
    });
  };

  const updateUser = (id, updatedUser) => {
    // alert(JSON.stringify(updatedUser.questionType));
    const addData = {
      checklistCategory: updatedUser.newCategory,
      checklistCreatedBy: userID,
      checklistDescription: updatedUser.name,
      checklistGroupId: checkGroupId,
      checklistId: id,
      checklistSubCategory: updatedUser.newSubCategory,
      oldChecklistCategory: updatedUser.category,
      oldChecklistSubCategory: updatedUser.subCategory,
      questionType: updatedUser.questionType,
      storeId: storeId,
    };
    setEditing(false);
    //alert(JSON.stringify(category));
    category.map((index, i) => {
      index.subCategory.map((index1, i1) => {
        category[i].subCategory[i1].name.map((index2, i2) => {
          if (id == index2.id) {
            category[i].subCategory[i1].name[i2].name = updatedUser.name;
          }
        });
      });
    });

    props.loadCat(category);

    ApiGateWay.Post(apiInterface + '/saveChecklistQuestion', addData)
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');
          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }
        toast.success('Question is Updated!');
        setTimeout(() => {
          props.refreshData();
        }, 2000);
      })
      .catch((error) => {
        toast.error('Something is went wrong please try again later!!');
      });
  };

  const editRow = (user) => {
    setEditing(true);

    setCurrentUser({
      id: user.id,
      name: user.name,
      category: user.category,
      subCategory: user.subCategory,
      newCategory: user.newCategory,
      newSubCategory: user.newSubCategory,
      questionType: user.questionType,
    });
  };

  return (
    <div
      className='container'
      style={{ marginLeft: '0px', position: 'sticky' }}
    >
      {modalOpen ? (
        <InfoMsgBox
          message={msg}
          headers={'initial message'}
          onClose={'handleClose'}
        />
      ) : null}

      <ToastContainer
        position='bottom-right'
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        className=''
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <div
        className='col-md-9'
        style={{ background: 'white', marginRight: '12px' }}
      >
        <UserTable
          users={users}
          editRow={editRow}
          accordianNo={no}
          category1={category}
          dataEmpty={props.dataEmpty}
          checkName={props.checkName}
          currentUser={currentUser}
          deleteUser={deleteUser}
        />
      </div>

      <Fragment>
        <CheckAddDialog
          addUser={addUser}
          users={category}
          checkName={props.checkName}
        />
      </Fragment>
      {editing ? (
        <Fragment>
          <CheckEditDialog
            editing={editing}
            setEditing={setEditing}
            currentUser={currentUser}
            updateUser={updateUser}
            checkName={props.checkName}
          />
        </Fragment>
      ) : (
        ''
      )}
    </div>
  );
};

export default CheckEdit;
